import "./Dashboard_new.css";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { Card_design } from "./Card_design";

export function Dashboard_new() {
  const [expandedAlgorithm, setExpandedAlgorithm] = useState(null);
  const API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";
  /* =========================================================
     STATE
  ========================================================= */

  const [alldata, setalldata] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  console.log("All tables data:", alldata);

  /* =========================================================
     ALGORITHMS
  ========================================================= */

  const algorithms = alldata?.algorithms || [];

  /*
   * Rank algorithms from highest confidence
   * to lowest confidence.
   */
  const rankedAlgorithms = [...algorithms].sort(
    (a, b) => Number(b.algorithim_confidence) - Number(a.algorithim_confidence)
  );

  /*
   * Algorithms below 50% confidence.
   */
  const weakeningAlgorithms = rankedAlgorithms
    .filter((algorithm) => Number(algorithm.algorithim_confidence) < 50)
    .sort(
      (a, b) =>
        Number(a.algorithim_confidence) - Number(b.algorithim_confidence)
    );

  /* =========================================================
     FETCH DATA
  ========================================================= */

  useEffect(() => {
    const fetchAllTeams = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          `${API_URL}/pastresult/getAllTableOnce`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        console.log("Dashboard API response:", data);

        setalldata(data?.final_return_data || null);
      } catch (err) {
        console.error("Dashboard fetch error:", err);

        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAllTeams();
  }, []);

  /* =========================================================
     EXPORT TO EXCEL
  ========================================================= */

  const exportMatchesToExcel = (data) => {
    if (!data || !Array.isArray(data.all_data) || data.all_data.length === 0) {
      alert("No data to export");
      return;
    }

    const matches = data.all_data;

    const rows = matches.map((m) => ({
      League: m.League,
      Schedule: m.Schedule,

      Home_Team: m.Home_Team,
      Away_Team: m.Away_Team,

      Home_Score: m.Home_score,
      Away_Score: m.Away_score,

      General_H_ExpG: m.general_H_exp_g,
      General_A_ExpG: m.general_A_exp_g,

      General_CS_1: m.general_CS_1,
      General_CS_2: m.general_CS_2,

      Odds_H_ExpG: m.odds_H_exp_g,
      Odds_A_ExpG: m.odds_A_exp_g,

      Odds_CS_1: m.odds_CS_1,
      Odds_CS_2: m.odds_CS_2,

      Form_H_ExpG: m.form_H_exp_g,
      Form_A_ExpG: m.form_A_exp_g,

      Form_CS_1: m.form_CS_1,
      Form_CS_2: m.form_CS_2,

      Home_Mean: m.H_mean,
      Away_Mean: m.A_mean,

      Home_CV: m.H_cv,
      Away_CV: m.A_cv,
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Match Analytics");

    XLSX.writeFile(workbook, "Match_Analytics.xlsx");
  };

  /* =========================================================
     LOADING
  ========================================================= */

  if (loading) {
    return (
      <div className="alg1_card dashboard_new">
        <div className="dashboard_loading">
          <div className="dashboard_spinner"></div>

          <span>Fetching dashboard data...</span>
        </div>
      </div>
    );
  }

  /* =========================================================
     ERROR
  ========================================================= */

  if (error) {
    return (
      <div className="alg1_card dashboard_new">
        <div className="dashboard_error">
          <strong>Unable to load dashboard</strong>

          <span>{error}</span>
        </div>
      </div>
    );
  }

  /* =========================================================
     MAIN DASHBOARD
  ========================================================= */

  return (
    <div className="alg1_card dashboard_new">
      {/* =====================================================
          HEADER
      ===================================================== */}

      <header className="dashboard_header">
        <div className="dashboard_header_title">
          <h1>ANALYTICS DASHBOARD</h1>

          <span>Monitor algorithm performance and trends</span>
        </div>

        <button
          className="export_excel_btn"
          onClick={() => exportMatchesToExcel(alldata)}
        >
          <span className="export_icon">↓</span>
          Export to Excel
        </button>
      </header>

      {/* =====================================================
          MAIN BODY

          LEFT  = 85%
          RIGHT = 15%
      ===================================================== */}

      <main className="dashboard_body">
        {/* ===================================================
            LEFT — ALGORITHM PERFORMANCE
        =================================================== */}

        <section className="dashboard_performance">
          <div className="dashboard_panel performance_panel">
            {/* SECTION HEADER */}

            <div className="dashboard_section_header">
              <div>
                <h2>Algorithm Performance</h2>

                <span>Current performance of all active algorithms</span>
              </div>

              <div className="algorithm_count">
                {algorithms.length}{" "}
                {algorithms.length === 1 ? "Algorithm" : "Algorithms"}
              </div>
            </div>

            {/* ALGORITHM CARDS */}

            <div className="algorithm_cards_grid">
              {algorithms.length > 0 ? (
                algorithms.map((algorithm) => {
                  const isExpanded =
                    expandedAlgorithm === algorithm.Algorithim_Name;

                  const isHidden = expandedAlgorithm !== null && !isExpanded;

                  return (
                    <div
                      className={`algorithm_card_wrapper ${
                        isExpanded ? "algorithm_card_expanded_wrapper" : ""
                      } ${isHidden ? "algorithm_card_hidden" : ""}`}
                      key={algorithm.Algorithim_Name}
                    >
                      <Card_design
                        title={algorithm.Algorithim_Name}
                        total_count={algorithm.Total_mathches}
                        percentage={algorithm.overall_accuracy}
                        correct_count={algorithm.correct_matches}
                        trend_direction={algorithm.trend_direction}
                        trend_change={algorithm.trend_change}
                        expanded={isExpanded}
                        onExpand={() =>
                          setExpandedAlgorithm(algorithm.Algorithim_Name)
                        }
                        onClose={() => setExpandedAlgorithm(null)}
                      />
                    </div>
                  );
                })
              ) : (
                <div className="empty_algorithms">
                  <div className="empty_icon">∅</div>

                  <strong>No algorithms available</strong>

                  <span>Algorithm performance data will appear here.</span>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* ===================================================
            RIGHT — TRENDING / WEAKENING / RECOMMENDATIONS
        =================================================== */}

        <aside className="dashboard_sidebar">
          {/* =================================================
              TRENDING
          ================================================= */}

          <section className="dashboard_panel trending_section">
            <div className="trend_header">
              <div>
                <h2>Algorithm Trending</h2>

                <span>Ranked by confidence</span>
              </div>
            </div>

            <div className="trend_list">
              {rankedAlgorithms.length > 0 ? (
                rankedAlgorithms.map((algorithm, index) => {
                  const confidence =
                    Number(algorithm.algorithim_confidence) || 0;

                  const change = Number(algorithm.trend_change) || 0;

                  const direction = algorithm.trend_direction || "stable";

                  return (
                    <div className="trend_item" key={algorithm.Algorithim_Name}>
                      {/* RANK */}

                      <div className="trend_rank">#{index + 1}</div>

                      {/* NAME */}

                      <div className="trend_algorithm">
                        <strong>{algorithm.Algorithim_Name}</strong>

                        <span>Accuracy: {algorithm.overall_accuracy}%</span>
                      </div>

                      {/* CONFIDENCE */}

                      <div className="trend_confidence">
                        <strong>{confidence.toFixed(1)}%</strong>

                        <span>Confidence</span>
                      </div>

                      {/* DIRECTION */}

                      <div className={`trend_direction ${direction}`}>
                        <span className="direction_arrow">
                          {direction === "improving" && "↑"}

                          {direction === "weakening" && "↓"}

                          {direction === "stable" && "→"}
                        </span>

                        <span>{direction}</span>

                        {change !== 0 && (
                          <small>
                            {change > 0 ? "+" : ""}
                            {change.toFixed(1)}%
                          </small>
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="no_algorithms">No algorithm data available.</p>
              )}
            </div>
          </section>

          {/* =================================================
              WEAKENING
          ================================================= */}

          <section className="dashboard_panel weakening_section">
            <div className="trend_header">
              <div>
                <h2>Weakening Algorithms</h2>

                <span>Confidence below 50%</span>
              </div>
            </div>

            <div className="weakening_list">
              {weakeningAlgorithms.length > 0 ? (
                weakeningAlgorithms.map((algorithm, index) => (
                  <div
                    className="weakening_item"
                    key={algorithm.Algorithim_Name}
                  >
                    <div className="weakening_rank">#{index + 1}</div>

                    <div className="weakening_name">
                      <strong>{algorithm.Algorithim_Name}</strong>

                      <span>
                        Confidence:{" "}
                        {Number(algorithm.algorithim_confidence).toFixed(1)}%
                      </span>
                    </div>

                    <div className="weakening_change">
                      ↓ {Math.abs(Number(algorithm.trend_change)).toFixed(1)}%
                    </div>
                  </div>
                ))
              ) : (
                <div className="no_weakening">
                  <span>✓</span>

                  <p>No algorithms currently below 50%</p>
                </div>
              )}
            </div>
          </section>

          {/* =================================================
              RECOMMENDATIONS
          ================================================= */}

          <section className="dashboard_panel recommendation_section">
            <div className="trend_header">
              <div>
                <h2>Recommendations</h2>

                <span>Suggested actions</span>
              </div>
            </div>

            <div className="recommendation_list">
              {weakeningAlgorithms.length > 0 ? (
                weakeningAlgorithms.slice(0, 3).map((algorithm) => {
                  const confidence =
                    Number(algorithm.algorithim_confidence) || 0;

                  const change = Number(algorithm.trend_change) || 0;

                  let recommendation;

                  if (confidence < 30) {
                    recommendation =
                      "Review the algorithm conditions. Recent performance is very weak.";
                  } else if (change < -10) {
                    recommendation =
                      "Performance is declining significantly. Review recent matches and consider adjusting the conditions.";
                  } else {
                    recommendation =
                      "Monitor this algorithm closely before changing its conditions.";
                  }

                  return (
                    <div
                      className="recommendation_item"
                      key={algorithm.Algorithim_Name}
                    >
                      <div className="recommendation_icon">!</div>

                      <div className="recommendation_content">
                        <strong>{algorithm.Algorithim_Name}</strong>

                        <p>{recommendation}</p>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="recommendation_good">
                  <span>✓</span>

                  <p>
                    All algorithms are currently performing above the 50%
                    confidence threshold.
                  </p>
                </div>
              )}
            </div>
          </section>
        </aside>
      </main>
    </div>
  );
}
